<template>
    <div class="full-wdith padding-box" v-loading="loading">
        <EditorTitle
            :showReturnBtn="true"
            :returnLabel="i18n.tkey('return')"
            :showOperationBtn="false"
            :titleLabel="i18n.tkey('lang_mall_manage')"
            @clickReturnBtn="clickReturnBtn"
            v-show="viewPart === 'home' && fullScreen !== false"
        />

        <div class="btn-flex-box" v-show="viewPart === 'home' && mallManageVisible">
            <div>
                <el-button-group>
                    <el-button
                        :type="dataType === 'create' ? 'primary' : ''"
                        @click="changeType('create')"
                    >
                        <span tkey="我的商場">{{i18n.tkey("lang_created_mall")}}</span>
                    </el-button>

                    <el-button
                        :type="dataType === 'create' ? '' : 'primary'"
                        @click="changeType('join')"
                    >
                        <span tkey="入駐商場">{{i18n.tkey("lang_join_mall")}}</span>
                    </el-button>
                </el-button-group>
            </div>

            <div>
                &nbsp;
            </div>

        </div>

        <div v-if="null != companyObj">
            <div v-if="dataType === 'create' && mallManageVisible">
                <CreatedMallEditor
                    :companyObj="companyObj"
                    @goEdit="viewPart = 'edit'"
                    @goList="viewPart = 'home'"
                />
            </div>

            <div v-if="dataType === 'join'">
                <JoinMallEditor
                    :companyObj="companyObj"
                    @changeView="changeViewCallback"
                />
            </div>
        </div>
    </div>
</template>

<script setup>

import {inject, getCurrentInstance, ref, toRef, onBeforeMount} from "vue";
import EditorTitle from "@/components/shopopee/common/editorTitle.vue";
import CreatedMallEditor from "@/components/shopopee/mall/createdMallEditor.vue";
import JoinMallEditor from "@/components/shopopee/mall/joinMallEditor.vue";
import {useUserinfo} from "@/stores/userinfo";
import companyApi from "@/request/companyApi";

const props = defineProps(["showReturnBtn", "fullScreen"])

const userInfoRef = toRef(useUserinfo())
const i18n = inject("i18n")
const { proxy } = getCurrentInstance()
const loading = ref(false)

const viewPart = ref("home")
const dataType = ref("create")

const companyObj = ref(null)
const showHeader = ref(true)
const mallManageVisible = ref(false)

const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return null } })

function clickReturnBtn(){
    if (viewPart.value !== "home"){
        viewPart.value = "home"
    }else{
        proxy.$router.push({name: "home"})
    }
}

function changeType(value){
    dataType.value = value
}

function fillCompanyObj(){
    companyObj.value = getShopCompanyObj()

    if (null == companyObj.value){
        getCompanyInfo()
    }else{
        setMallManageVisible()
    }

}

function getCompanyInfo(){
    loading.value = true

    const request = companyApi.getCompanyInfo
    const params = request.getParams()

    params.companycode = userInfoRef.value.selectCompanycode

    request.send(params, (res) => {
        loading.value = false
        if (res.code == 200){
            const obj = res.detail

            if (null != obj.additionalrecord11 && null != obj.additionalrecord11.addremark1){
                obj.additionalrecord11 = JSON.parse(obj.additionalrecord11.addremark1)
            }

            companyObj.value = obj
            setMallManageVisible()
        }
    })

}

function changeViewCallback(name){
    if (name === "product"){
        viewPart.value = "edit"
    }else{
        viewPart.value = "home"
    }
}

function setMallManageVisible(){
    let flag = (null != companyObj.value.additionalrecord11 && null != companyObj.value.additionalrecord11.mallNum && companyObj.value.additionalrecord11.mallNum > 0)
    mallManageVisible.value = flag

    if (flag == false){
        dataType.value = "join"
    }

}

onBeforeMount(() => {
    fillCompanyObj()
})

</script>

<style scoped>
    .btn-flex-box {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .full-wdith {
        width: 100%;
        height: 100%;
        overflow-x: hidden;
        overflow-y: auto;
        box-sizing: border-box;
        position: relative;
    }

    .padding-box {
        padding: 10px;
        box-sizing: border-box;
        text-align: left;
    }

    .content-box {
        margin-top: 20px;
    }
</style>